import React, { forwardRef } from 'react';
import { cn } from '../../../lib/utils';

/**
 * OrkaTaskMoveHandle — labelled six-dot drag handle (PRD §5.1, Code Reference §4.1).
 *
 * THE Move affordance. Visually and semantically distinct from MenuButton.
 * This component is the ONLY place `data-orka-move-handle="true"` should appear.
 *
 *   <OrkaTaskMoveHandle aria-label="Move task" />
 */
export const OrkaTaskMoveHandle = forwardRef(function OrkaTaskMoveHandle(
  { className, label = 'Move', size = 'md', ...rest },
  ref,
) {
  const dotSize = size === 'sm' ? 2 : 2.5;
  const wrapperW = size === 'sm' ? 14 : 18;
  return (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      data-orka-move-handle="true"
      data-testid="orka-move-handle"
      className={cn(
        'inline-flex items-center justify-center rounded shrink-0',
        'cursor-grab active:cursor-grabbing',
        'orka-text-tertiary hover:orka-text-secondary',
        'orka-transition-colors orka-focus-ring',
        size === 'sm' ? 'w-5 h-5' : 'w-6 h-6',
        className,
      )}
      {...rest}
    >
      <svg width={wrapperW} height={wrapperW} viewBox="0 0 18 18" aria-hidden="true">
        {/* Six-dot grid */}
        {[0, 1, 2].map((row) => (
          [0, 1].map((col) => (
            <circle
              key={`${row}-${col}`}
              cx={6 + col * 6}
              cy={3 + row * 6}
              r={dotSize / 2}
              fill="currentColor"
            />
          ))
        ))}
      </svg>
    </button>
  );
});

export default OrkaTaskMoveHandle;
